module.exports = __webpack_public_path__ + "media/images/hakone/hankyu_hakone_zh-hans02-64bbcad221fe9b365eebc5ca3d98facf.jpg";